<app-supplier-auction-offer-list-ssy1280detail [state]="viewState.Edit"></app-supplier-auction-offer-list-ssy1280detail>